import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const PilotageModal = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  onSubmit,
  submitLabel = "Enregistrer",
  isSubmitting = false,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl border-white/10 bg-slate-950 text-white p-0 overflow-hidden flex flex-col max-h-[90dvh]">
        <div className="p-6 pb-4 shrink-0 border-b border-white/10 bg-slate-950 z-10">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            {description ? (
              <DialogDescription className="text-slate-400">
                {description}
              </DialogDescription>
            ) : null}
          </DialogHeader>
        </div>
        <form className="flex flex-col flex-1 overflow-hidden" id="pilotage-form" onSubmit={onSubmit}>
          <div className="p-6 overflow-y-auto flex-1 space-y-5 custom-scrollbar">
            {children}
          </div>
          <div className="p-6 pt-4 shrink-0 border-t border-white/10 bg-slate-950 z-10">
            <DialogFooter>
              <Button
                type="button"
                variant="outline"
                onClick={() => onOpenChange(false)}
                className="border-white/10 text-slate-300 hover:bg-white/5 hover:text-white"
              >
                Annuler
              </Button>
              <Button type="submit" form="pilotage-form" className="btn-primary" disabled={isSubmitting}>
                {isSubmitting ? "Enregistrement..." : submitLabel}
              </Button>
            </DialogFooter>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PilotageModal;
